import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false); // Cerrar menú móvil después de navegar
    }
  };

  const menuItems = [
    { id: 'el-cercado', label: 'El Pueblo' },
    { id: 'el-oficio', label: 'El Oficio' },
    { id: 'los-artesanos', label: 'Artesanos' },
    { id: 'las-piezas', label: 'Las Piezas' },
    { id: 'visitas-clases', label: 'Experiencias' },
    { id: 'visita', label: 'Contacto' }
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-cal/95 backdrop-blur-md shadow-md'
            : 'bg-transparent'
        }`}
      >
        <div className="editorial-container">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="display-heading text-2xl md:text-3xl text-earth hover:text-siena transition-colors duration-300"
            >
              El Cercado
            </button>

            {/* Desktop Navigation Links */}
            <div className="hidden md:flex items-center gap-8">
              {menuItems.slice(0, 5).map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="nav-label hover:text-siena-dark transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => scrollToSection('visita')}
                className="bg-siena hover:bg-siena-dark text-white font-sans text-sm uppercase tracking-wider transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Contacto
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-earth hover:text-siena p-2 transition-colors"
              aria-label="Abrir menú"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-earth/80 backdrop-blur-sm"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          
          {/* Menu Panel */}
          <div className="absolute top-20 right-0 bottom-0 w-[280px] bg-cal shadow-2xl animate-fade-in">
            <div className="flex flex-col h-full">
              {/* Menu Items */}
              <nav className="flex-1 py-6 overflow-y-auto">
                {menuItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="w-full text-left px-6 py-4 text-base font-medium text-earth hover:bg-siena/10 hover:text-siena transition-colors border-b border-stone-light/50"
                  >
                    {item.label}
                  </button>
                ))}
              </nav>

              {/* Footer CTA */}
              <div className="p-6 border-t border-stone-light">
                <Button
                  onClick={() => scrollToSection('visita')}
                  className="w-full bg-siena hover:bg-siena-dark text-white font-sans text-sm uppercase tracking-wider py-6"
                >
                  Reservar ahora
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
